<template>
  <div>
    <!-- Modal Login -->
    <div class="modal fade" id="modalLogin" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">เข้าสู่ระบบ Horga</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <i class="fas fa-times close-modal"></i>
            </button>
          </div>
          <div class="modal-body">
            <div style="margin-top: 10px;padding:15px;">
            <h5 style="margin-bottom: 15px;">เข้าสู่ระบบด้วย Horga</h5>
            <a :href="`${$webAppUrl}/login?redirect=marketplace${productId ? `&productId=${productId}` : ``}${purchasingType ? `&purchasingType=${purchasingType}` : ``}`" target="_blank"><button class="btn-main" style="width: 100%;">เข้าสู่ระบบ</button></a>
            <hr style="margin:13px;">
            <a :href="`${$webAppUrl}/pre-signup?utm_source=marketplace`" target="_blank"><h6>สมัครสมาชิก</h6></a>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      productId:""
    }
  },
  methods: {
  },
  computed: {
    ...mapState([
      'purchasingType'
    ])
  },
  watch: {
    '$route.params.productId': function(){
      this.productId = this.$route.params.productId
    }
  },
}
</script>
<style scoped>
.modal-header{
  padding: 10px;
  background: #f1f1f1;
}
a{
  color: rgb(80, 80, 80);
}
i{
  background: rgb(170, 170, 170);
  padding: 5px;
  border-radius: 50%;
  width: 34px;
  height: 34px;
}
.modal-title{
  font-weight: bold;
  color: rgb(80, 80, 80);
}
.modal-body{
  color: rgb(80, 80, 80);
  text-align: center;

}
</style>